
import Vue from 'vue';
import ABaseComponent from 'Components/Base/ABaseComponent';
import Component from 'vue-class-component';
import barcodeStore from 'Store/barcode/barcodestore';
import { ScannedBarcode, ScannedBarcodeState, TakeItemOutOfCirculationCommandResponse, UpdateBarcodeListCommandArguments, UpdateBarcodeListCommandArgumentsState, TakeItemOutOfCirculationViewModel, ScannedBarcodeDetailsViewModel, DownloadBarcodeListRequestArguments } from 'Api/CoreApi';
import store from 'Store/store';
import barcodestore from 'Store/barcode/barcodestore';
import { xor } from 'lodash-es';
import { Prop, Mixins } from 'vue-property-decorator';
import ABarcodeActionsComponent from './ABarcodeActionsComponent';
import ApiProvider from 'Api/ApiProvider';

@Component({
    template: '#barcode-take-item-out-of-circulation-template'
})
export class BarcodeTakeItemOutOfCirculationComponent extends ABarcodeActionsComponent {
    

    list: TakeItemOutOfCirculationViewModel[] = null;

    async created() {
        
        this.availableStates = Object.keys(ScannedBarcodeState)
        .map(key => key)
        .filter(value => value == ScannedBarcodeState.AFKEUR);
        this.setLoaded();
    }
    

    getBarcodeDetails(index: number): ScannedBarcodeDetailsViewModel{
        if(!this.list || !this.list[index]) return;

        return this.list[index].details;
    }
    clearList(){
        this.list = [];
        barcodestore.clearList();
        barcodestore.add();
    }

    async validateScannedBarcodes(){ 
                
        this.triggerValidateOnTable = false;
        this.waiting = true;
        this.errorValidate = false;
        this._isValidated = false;
        

            this.triggerValidateOnTable = true;                    
        try{
      
            
            const result = await this.validate(this.selectedState);
            this._isValidated = result.isValid;
            this.errorValidate = !result.isValid;
            
        }catch(error){
            this.errorValidate = true;
            this._isValidated = false;
            console.log("error caught",error);
            
            console.log(error);
            console.log(this.list);
            
        }
        this.waiting = false;
    }
    async exportValidatedBarcodes(){
        if(!this.list) return;
        //map model to export obj
        
        const client = ApiProvider.getApiClient();
        const result = await client.downloadScannedBarcodes(<DownloadBarcodeListRequestArguments>{
            list: this.list
        });
        
        console.debug('export response: ', result);
        console.debug('export content: ', atob(result.content));
        
        await this.export(this.selectedState,result.json);
    }
    async validate(status : string): Promise<TakeItemOutOfCirculationCommandResponse>{
        console.log(this.selectedState);
        

        if(!this.barcodes) return;

        const distinctBarcodeNo = (value: ScannedBarcode, index: number, collection: ScannedBarcode[]) => {
            return collection.map(x => x.number).indexOf(value.number) === index;
        }
        //remove duplicates
        let distinctBarcodes = this.barcodes.filter(distinctBarcodeNo)
        const client = ApiProvider.getApiClient();
        console.log("here");
        
        const result = await client.takeItemOutOfCirculation(<UpdateBarcodeListCommandArguments>{
            state: status as UpdateBarcodeListCommandArgumentsState,
            scannedBarcodeList: distinctBarcodes
        });
        console.log("but here?",result);
        this.errorValidate = !result.isValid;
        barcodestore.updateList(result.list.map(x => x.item));
        
        this.list = result.list;

        //map validated barcodes to store !
        //add validation list to component
        return result;
    }
    
}
Vue.component('barcode-take-item-out-of-circulation', BarcodeTakeItemOutOfCirculationComponent);